import React, { useState } from "react";
import { DeleteOutlined, WarningFilled } from "@ant-design/icons";
import { Modal } from "antd";

interface ClearAllButtonProps {
    onClear: () => void;
    confirmMessage?: string;
}

const ClearAllButton = ({
    onClear,
    confirmMessage = "Are you sure you want to clear all items?",
}: ClearAllButtonProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleConfirm = () => {
        setIsModalOpen(false);
        onClear();
    };

    return (
        <>
            <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                className="btn d-flex align-items-center gap-2"
                title="Clear all items"
                style={{
                    borderRadius: "50px",
                    padding: "7px 16px",
                    fontSize: "14px",
                    fontWeight: 600,
                    transition: "all 0.2s ease",
                    backgroundColor: "rgb(255, 233, 220)",
                    borderColor: "#dc3545",
                    color: "#dc3545",
                    borderStyle: "solid",
                    borderWidth: "1.5px",
                    boxShadow: "0 2px 6px rgba(220, 53, 69, 0.12)",
                    lineHeight: 1.25,
                }}
            >
                <DeleteOutlined style={{ fontSize: "14px" }} />
                <span className="d-none d-md-inline">Clear All</span>
                <span className="d-inline d-md-none">All</span>
            </button>

            <Modal
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                centered
                closable={false}
                width={380}
                styles={{
                    body: {
                        padding: "16px 8px",
                        textAlign: "center",
                    },
                }}
            >
                <div className="d-flex flex-column align-items-center text-center">
                    <div
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(250, 140, 22, 0.12)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: "16px",
                        }}
                    >
                        <WarningFilled style={{ fontSize: "32px", color: "#fa8c16" }} />
                    </div>

                    <h4
                        style={{
                            fontWeight: 700,
                            color: "#2b3034",
                            marginBottom: "8px",
                            fontSize: "1.2rem",
                        }}
                    >
                        Clear all Items?
                    </h4>

                    <p
                        style={{
                            color: "#6b7280",
                            fontSize: "0.95rem",
                            lineHeight: 1.5,
                            marginBottom: "22px",
                        }}
                    >
                        {confirmMessage}
                        <br />
                        <span style={{ fontSize: "0.85rem", color: "#9ca3af" }}>
                            This action cannot be undone.
                        </span>
                    </p>

                    <div className="d-flex gap-3 w-100 justify-content-center">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => setIsModalOpen(false)}
                            style={{
                                borderRadius: "50px",
                                padding: "8px 22px",
                                fontWeight: 600,
                                minWidth: "100px",
                                border: "1px solid #d1d5db",
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger d-flex align-items-center justify-content-center gap-2"
                            onClick={handleConfirm}
                            style={{
                                borderRadius: "50px",
                                padding: "8px 22px",
                                fontWeight: 600,
                                minWidth: "120px",
                                backgroundColor: "#dc2626",
                                borderColor: "#dc2626",
                            }}
                        >
                            <DeleteOutlined />
                            <span>Clear all</span>
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ClearAllButton;
